import { render, staticRenderFns } from "./lastPay.vue?vue&type=template&id=486147d0&scoped=true"
import script from "./lastPay.vue?vue&type=script&lang=js"
export * from "./lastPay.vue?vue&type=script&lang=js"
import style0 from "./lastPay.vue?vue&type=style&index=0&id=486147d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486147d0",
  null
  
)

export default component.exports